$(function() {
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 20) {
            $(".lg-logo").addClass('hide_logo');
            $("#hoh_logo").addClass('show_logo');            
        } else {
          $(".lg-logo").removeClass('hide_logo');
           $("#hoh_logo").removeClass('show_logo');          
        }
    });
});